import React from 'react'
import {Modal} from 'react-bootstrap'
import {useIntl} from 'react-intl'
import {ROUTES} from '../../../../../_gori/constants'
import {Link} from 'react-router-dom'

type Props = {
  show: boolean
  handleClose: any
}

const SeeDetailModal: React.FC<Props> = ({show, handleClose}) => {
  const intl = useIntl()

  return (
    <>
      <Modal tabIndex={-1} aria-hidden='true' centered show={show} backdrop='static' size={'lg'}>
        <Modal.Body className=''>
          <div className={'py-3'}>
            <button
              type='button'
              className='btn-close position-absolute top-0 end-0 m-3'
              aria-label='Close'
              onClick={handleClose}
            ></button>
          </div>
          <div>
            <p>
              {intl.formatMessage({id: 'SERVICE_SEE_DETAIL_CONTENT'})}{' '}
              {intl.formatMessage({id: 'COST_PER_DVU'})}{' '}
              {intl.formatMessage({id: 'FOR_MORE_INFO_VISIT'})}{' '}
              <Link
                className='text-decoration-underline fw-bold'
                to={ROUTES.HELP_CENTER.BAE_GUARD}
                target='_blank'
                rel='noreferrer'
              >
                {intl.formatMessage({id: 'HELP_CENTER'})}
              </Link>
            </p>
          </div>
        </Modal.Body>
      </Modal>
    </>
  )
}

export {SeeDetailModal}
